import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppState } from 'app/store/app.state';
import { clockIn } from 'app/store/timesheet/timesheet.action';

@Component({
  selector: 'app-clock-night-shift-dialog',
  templateUrl: './clock-night-shift-dialog.component.html',
  styleUrls: ['./clock-night-shift-dialog.component.scss'],
  standalone: false,
})
export class ClockNightShiftDialogComponent implements OnInit {
  form!: FormGroup;
  constructor(
    private store: Store<AppState>,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<ClockNightShiftDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { projectId: number }
  ) {}
  ngOnInit(): void {
    this.setForm();
  }

  setForm() {
    this.form = this.fb.group({
      projectId: [this.data.projectId],
    });
  }

  onHandleSubmit(): void {
    if (this.form.invalid) return;
    this.store.dispatch(clockIn(this.form.value));
  }
}
